import type { WidgetLayout } from '@proadv/types';

/**
 * Layout default da pagina de atividades. Grid 4 colunas x 3 linhas.
 *
 *   Linha 1-3 (y=0) | chart (2×2) | produtividade (1×2) | calendario (1×2) |
 *
 * Os 3 widgets ocupam a linha superior inteira do grid.
 */
export const ATIVIDADES_DEFAULT_LAYOUT: WidgetLayout[] = [
  { widgetId: 'tasks_activity_chart', x: 0, y: 0, w: 2, h: 2 },
  { widgetId: 'tasks_productivity', x: 2, y: 0, w: 1, h: 2 },
  { widgetId: 'tasks_calendar_count', x: 3, y: 0, w: 1, h: 2 },
];
